import React, { Component } from "react";
import Intro from "./components/intro.component";
import Menu from "./components/menu.component";
import { Redirect } from "react-router-dom";

class HomePage extends Component {
  render() {
    if (!localStorage.getItem("token")) {
      return <Redirect to="/login"></Redirect>;
    }
    return (
      <div>
        <Intro />
      </div>
    );
  }
}

export default HomePage;
